module.exports = __webpack_public_path__ + "img/micoma_banner_sp.14abae05.png";